








































































































































































































































































































































/** 2022-12-08 sh #8122(BQR982) reload after change shaken-shurui. [START] */
// import { Component, Vue } from "vue-property-decorator";
import { Component, Vue, Watch } from "vue-property-decorator";
/** 2022-12-08 sh #8122(BQR982) reload after change shaken-shurui. [END] */
import ButtonInspect from "@/components/common/button/ButtonInspect.vue";
import requestService from "@/service/requestService";
import { Staff } from "@/model/Staff";
import { Getter, Action } from "vuex-class";
import {
  AssignmentWork,
  WorkItem,
  WorkBuhin,
  SeibiStaff
} from "@/model/AssignmentWork";
import SaveDialog from "@/components/common/SaveDialog.vue";
import ConfirmDialog from "@/components/common/ConfirmDialog.vue";
import { MESSAGE } from "@/model/Message";
import { inspectService } from "@/service/inspectService";
import * as util from "@/service/util";
import { InspectStaff } from "@/model/InspectStaff";
import EstimateListComponent from "@/components/EstimateListComponent.vue";
import { SocketControllers } from "@/service/SocketControllers";

@Component({
  components: {
    ButtonInspect,
    SaveDialog,
    ConfirmDialog,
    EstimateListComponent
  }
})
export default class WorkOrder extends Vue {
  reqService: requestService;
  sktControll: SocketControllers;
  staffs: any[] = [];
  addStaffs: any[] = [];
  filterField: any = null;
  kyotenCd: string = "";
  currentKyotenCd: string = "";
  // workData: AssignmentWork;
  workItem: WorkItem[] = [];
  manualList: any = null;
  activeWork: string = "";
  disabledSave: boolean = true;
  errorMsg: string = "";
  loadingText: string = MESSAGE.Loading;
  loading: boolean = false;
  inspectService: inspectService;
  workData: AssignmentWork = {};
  isUserMode: boolean = false;
  showDialogStaff: boolean = false;
  otherStaffList: InspectStaff[] = [];
  otherStaffData: InspectStaff[] = [];
  tempOtherStaff: any = null;

  //addStaffMaxの数だけ選択できる。
  //現状(1..3) それ以上にするときはソース内のtempAddStaffを全部増やす必要がある
  //又、24の約数である必要がある
  changeStaffMode : boolean = false;
  addStaffMax : number = 1; //同時に追加選択する人数
  tempAddStaff1: any = null;
  tempAddStaff2: any = null;
  tempAddStaff3: any = null;
  showDialogStaffSlot: boolean = false;
  checkedStaffSlot: any=[]; //削除交換対象の選択状態保持
  
  tempWork: WorkItem | null = null;
  kyotenList: any = [];
  showDialogRecommend: boolean = false;
  estData: any = {};
  @Getter("uketsukeExtendsId", { namespace: "ReservationDetail" })
  uketsukeExtendsId: number;
  @Getter("uketsukeCd", { namespace: "ReservationDetail" })
  uketsukeCd: string;
  @Getter("yoyakuNo", { namespace: "ReservationDetail" })
  yoyakuNo: string;

  // @Getter("currentState", { namespace: "WorkOrder" })
  // workData: AssignmentWork;

  // @Action("setState", { namespace: "WorkOrder" })
  // setState: any;

  @Action("setWorkStaff", { namespace: "WorkOrder" })
  setWorkStaff: any;

  /** 2021-08-27 sh #7372 fix button of jizen mitsumori. [START] */
  @Getter("isCanJizenMitsumori", { namespace: "FunctionSetting"} )
  isCanJizenMitsumori: any;
  /** 2021-08-27 sh #7372 fix button of jizen mitsumori. [END] */

  /** 2021-09-10 sh #7372 fix button of jizen mitsumori.(check JizenCd from MD-0002 ) [START] */
  @Getter("isDoJizen", { namespace: "InspectionDetail" })
  isDoJizen: boolean;
  /** 2021-09-10 sh #7372 fix button of jizen mitsumori.(check JizenCd from MD-0002 ) [END] */

  /** 2022-12-08 sh #8122(BQR982) reload after change shaken-shurui. [START] */
  @Getter("seibiMenuCd", { namespace: "InspectionDetail" })
  seibiMenuCd: string;
  /** 2022-12-08 sh #8122(BQR982) reload after change shaken-shurui. [END] */

  title: string = "";
  joukyouErrorMsg: string = "";

  $refs!: {
    saveDialog: SaveDialog;
    errorDialog: ConfirmDialog;
    cancelDialog: ConfirmDialog;
    joukyouDialog: ConfirmDialog;
  };

  get seibiListByResult() {
    return this.inspectService.getSeibiListByResult(
      this.workData.items,
      this.workData.manualItems
    );
  }

  inspectResClass(index: number) {
    const mode = index > 1 ? 2 : 0;
    return this.inspectService.inspectResClassTitle(index, mode);
  }

  getTextTitle(index: number) {
    let inspectResult = index;

    //工場側、ユーザー側、どちらで追加した手入力も「お奨め」で表記している
    if( index == 5 || index == 6 ) inspectResult = 2;
    
    return inspectResult <= 1 ? "検査結果" : inspectResult == 2 ? "お奨め整備" : "";
  }

  created() {
    if (this.$route.meta == "user") {
      this.isUserMode = true;
    }
    this.$emit("onactivepage", this.$route.name);
    this.reqService = new requestService();
    this.sktControll = new SocketControllers();
    this.inspectService = new inspectService();
    this.sktControll.connectSocket(this.onConnect);
    const kyoten = window.localStorage.getItem("kyotenCd");
    if (kyoten) {
      this.kyotenCd = kyoten;
      this.currentKyotenCd = kyoten;
    }
    this.reqService.getKyotenList().then((res: any) => {
      if (res) {
        this.kyotenList = res;
      }
    });
    this.getData(true);
  }

  getStaff(kyotenCd = "") {
    if (kyotenCd) {
      this.kyotenCd = kyotenCd;
    } else if (
      this.tempWork &&
      this.tempWork.otherStaff &&
      this.tempWork.otherStaff.kyotenCd
    ) {
      this.kyotenCd = this.tempWork.otherStaff.kyotenCd;
    } else {
      this.kyotenCd = this.currentKyotenCd;
    }
    if (this.kyotenCd == this.currentKyotenCd) {
      if (this.otherStaffList.length > 0) {
        this.setOtherStaffList();
      } else if (this.tempWork) {
        let workId;
        let isManual = false;
        if (this.tempWork.inspectSeibi.sknHiyouManualWorkId) {
          isManual = true;
          workId = this.tempWork.inspectSeibi.sknHiyouManualWorkId;
        } else {
          workId = this.tempWork.inspectSeibi.sknHiyouInspectWorkId;
        }
        this.reqService
          .getOtherStaffList(this.uketsukeExtendsId, workId, isManual)
          .then(
            (res: any) => {
              if (res && res.length > 0) {
                this.otherStaffData = res;
              } else {
                this.otherStaffData = [];
              }
              this.setOtherStaffList();
            },
            error => {
              this.otherStaffData = [];
            }
          );
      }
    } else {
      this.getStaffByKyoten(this.kyotenCd);
    }
  }

  getStaffByKyoten(kyotenCd: any) {
    this.reqService.getStaffs(kyotenCd).then(
      (res: any) => {
        let staffs = [];
        if (res) {
          staffs = res;
        }
        this.$set(this, "staffs", staffs);
        this.setSelectedStaff();
      },
      error => {
        this.$set(this, "staffs", []);
      }
    );
  }
  
/** 2024-02-26 change staff [START] */
  getStaffAddList(kyotenCd = "") {

    if (kyotenCd) {
      this.kyotenCd = kyotenCd;
    } else {
      this.kyotenCd = this.currentKyotenCd;
    }
    
    if (this.kyotenCd == this.currentKyotenCd) {
      //マニュアル作業の対応出来てないかも
      let workId;
      let isManual = false;
    //  if (this.tempWork.inspectSeibi.sknHiyouManualWorkId) {
    //    isManual = true;
    //    workId = this.tempWork.inspectSeibi.sknHiyouManualWorkId;
    //  } else {
    //    workId = this.tempWork.inspectSeibi.sknHiyouInspectWorkId;
    //  }
        this.reqService
          .getStaffList(this.uketsukeExtendsId, workId, isManual)//※通常と取り方が違う
          .then(
            (res: any) => {
              if (res && res.length > 0) {
                this.addStaffs = res;
              } else {
                this.addStaffs = [];
              }
            },
            error => {
              this.addStaffs = [];
            }
          );
      //}
    } else {
      this.reqService.getStaffs(kyotenCd).then(
      (res: any) => {
        if (res) {
          this.addStaffs = res;
        } else{
          this.addStaffs = [];
        }
      },
      error => {
        this.addStaffs = [];
      }
    );
    }
  }
/** 2024-02-26 change staff [END] */

  setSelectedStaff() {
    if (this.tempWork != null && this.tempWork.otherStaff) {
      let staffCd = this.tempWork.otherStaff.staffCd;
      this.staffs.forEach(
        (e: InspectStaff) => (e.selected = staffCd == e.staffCd ? "1" : "0")
      );
    } else {
      this.staffs.forEach((e: InspectStaff) => (e.selected = "0"));
    }
  }

  getData(isFirstGet: boolean = false) {
    this.$set(this, "loading", true);
    this.reqService
      .getAssignmentWork(this.uketsukeExtendsId,0)
      .then((res: any) => {
        if (res) {
          const items = this.inspectService.filterWorkOrder(res.items);
          const manualItems = this.inspectService.filterWorkOrder(
            res.manualItems
          );
          this.$set(this, "workData", { ...res, items, manualItems });
          if (this.workData.items) {
            this.workItem = this.workData.items;
            if (
              this.workData.manualItems &&
              this.workData.manualItems.length > 0
            ) {
              this.workItem = this.workItem.concat(this.workData.manualItems);
            }

            this.checkComplete();
            if (isFirstGet && res.seibiNotSelect) {
              this.errorMsg = MESSAGE.SeibiNotSelectDotenken;
              this.$refs.errorDialog.onOpen();
            }
            // console.log('workData', JSON.parse(JSON.stringify(this.workData)));
          } else {
            this.disabledSave = false;
          }
        }
        this.$set(this, "loading", false);
      });
  }

  isActiveWork(gIdx: number, idx: number) {
    return "s" + gIdx + idx == this.activeWork;
  }

  // isDanaJisha(work: WorkItem) {
  //   return work.inspectSeibi.isBuhinDanaJisha == 1;
  // }

  // isDanaItaku(work: WorkItem) {
  //   return work.inspectSeibi.isBuhinDanaItaku == 1;
  // }

  // isGaichu(work: WorkItem) {
  //   return work.inspectSeibi.isGaichu == 1;
  // }

  isBuhinWaiting(work: WorkItem) {
    return work.inspectSeibi.isBuhinWaiting == 1;
  }

  changeIsWaiting(work: WorkItem, e: any) {
    e.stopPropagation();
    if (work.inspectSeibi.isBuhinWaiting == 1) {
      work.inspectSeibi.isBuhinWaiting = 0;
    } else {
      work.inspectSeibi.isBuhinWaiting = 1;
      work.inspectSeibi.seibiJoukyou = 0;
    }
    this.checkComplete();
    // this.setState({ ...this.workData });
  }

  changeIsAssign(staff: SeibiStaff, e: any, index: number) {
    e.stopPropagation();
    if (staff.isAssignee == 1) {
      staff.isAssignee = 0;
    } else {
      staff.isAssignee = 1;
    }

    // this.setState({ ...this.workData });
    console.log(
      "changeIsAssign -> staff",
      JSON.parse(JSON.stringify(this.workData))
    );
  }

  isSeibiJoukyou(work: WorkItem) {
    return work.inspectSeibi.seibiJoukyou == 1;
  }

  changeSeibiJoukyou(work: WorkItem, e: any) {
    e.stopPropagation();
    if (work.inspectSeibi.seibiJoukyou == 1) {
      work.inspectSeibi.seibiJoukyou = 0;
    } else {
      work.inspectSeibi.seibiJoukyou = 1;
    }
    this.checkComplete();
    // this.setState({ ...this.workData });
  }

  deleteBuhin(buhin: WorkBuhin) {
    if (buhin.isDelete == 1) {
      buhin.isDelete = 0;
    } else {
      buhin.isDelete = 1;
    }
  }

  checkComplete() {
    //非表示項目(しないor後日)と完了にした検査をカウントして整備完了ボタンを解放する
    const nFinish: number = this.workItem.filter(
      work => ( work.inspectSeibi.seibiJoukyou == 1 && work.inspectSeibi.doTenken == 1 )
    ).length;
    const nHidden: number = this.workItem.filter(
      work => work.inspectSeibi.doTenken != 1
    ).length;

    if (this.workItem.length == 0) {
      this.disabledSave = false;
    } else if (this.workItem.length == nFinish + nHidden) {
      this.disabledSave = false;
    } else {
      this.disabledSave = true;
    }
  }

  onRegister() {
    // this.setState({ ...this.workData });
    if(!this.loading){
      this.loading = true;
      this.saveData(1).then(
        (res: any) => {
          this.getData(true);
          this.$emit("saveSpentTime");
          this.$emit("onregister", { pageName: this.$route.name });
          this.loading = false;
        },
        (res: any) => {
          this.onSaveError(res);
        }
      );
    }
  }

  onSaveError(res: any) {
    this.loading = false;
    if (res.status < 500 && res.rsltComment) {
      this.errorMsg = res.rsltComment;
    } else {
      this.errorMsg = MESSAGE.SystemError;
    }
    this.$refs.errorDialog.onOpen();
  }

  onSave() {
    // this.setState({ ...this.workData });
    if(!this.loading){
      this.loading = true;
      this.saveData(0).then(
        (res: any) => {
          this.getData(true);
          this.$emit("saveSpentTime");
          this.$refs.saveDialog.onOpen();
          this.loading = false;
        },
        (res: any) => {
          this.onSaveError(res);
        }
      );
    }
  }

  saveData(btn: number) {
    this.workData.btnAction = btn;
    if (this.workData.items == null) {
      this.workData.items = [];
    }
    if (this.workData.manualItems == null) {
      this.workData.manualItems = [];
    }
    return this.reqService.saveAssignmentWork(this.workData);
  }

  onInspectTime(frame: any) {
    const body = util.getWSData(frame);
    if (body.screenId == 6 && this.isUserMode) {
      this.getData();
    }
  }

  onConnect() {
    if (this.sktControll.checkSocket()) {
      if (this.isUserMode) {
        this.sktControll.socketExtends(this.onInspectTime);
      }

      //this.sktControll.socketInspections(this.onInspectionDotenken);
      //▽[2024/03/21]kyuwa : カミタケ様向け仕様のため一旦封印
      /*
      this.sktControll.socketWorkCompleted(this.onAddWork);
      this.sktControll.socketWorkRemoved(this.onRemoveWork);
      */
      //△[2024/03/21]kyuwa : カミタケ様向け仕様のため一旦封印

      /* 2024-03-21 牧 衝突調整 [START]*/
      /*this.workSubscription = this.socket.client.subscribe(
        `/connect/factory/work-order/${this.uketsukeCd}${
          this.yoyakuNo
        }/completed`,
        this.onChangeWork
      );*/
      this.sktControll.socketWorkCompleted(this.onChangeWork);
      /* 2024-03-21 牧 衝突調整 [END]*/
    } else {
      this.sktControll.socketPayments(this.onfactoryGetData);
    }
  }

  //▽[2024/03/21]kyuwa : カミタケ様向け仕様のため一旦封印
  /*
  onAddWork(frame: any) {
    const body = util.getWSData(frame);
    if (body && body.length > 0) {
      if (
        body[0].inspectSeibi.sknUketsukeManualSeibiId != null &&
        this.workData.manualItems
      ) {
        this.workData.manualItems = this.workData.manualItems.concat(body);
      } else if (this.workData.items) {
        this.workData.items = this.workData.items.concat(body);
      }
      this.$forceUpdate();

      //退避リストからは削る
      if (body[0].inspectSeibi.sknUketsukeManualSeibiId && this.workDataAfter.manualItems) {
        const index = this.workDataAfter.manualItems.findIndex(
          (e: any) =>
            e.inspectSeibi.sknUketsukeManualSeibiId ==
            body[0].inspectSeibi.sknUketsukeManualSeibiId
        );
        if (index > -1) {
          this.workDataAfter.manualItems.splice(index, 1);
          this.$forceUpdate();
        }
      } else if (body[0].inspectSeibi.sknUketsukeInspectSeibiId && this.workDataAfter.items) {
        const index = this.workDataAfter.items.findIndex(
          (e: any) =>
            e.inspectSeibi.sknUketsukeInspectSeibiId ==
            body[0].inspectSeibi.sknUketsukeInspectSeibiId
        );
        if (index > -1) {
          this.workDataAfter.items.splice(index, 1);
          this.$forceUpdate();
        }
      }
    }
  }
  */
  //△[2024/03/21]kyuwa : カミタケ様向け仕様のため一旦封印

  
  //▽[2024/03/21]kyuwa : カミタケ様向け仕様のため一旦封印
  /*
  onRemoveWork(frame: any) {
    const body = util.getWSData(frame);
    if (body && body.length > 0) {
      if (body[0].inspectSeibi.sknUketsukeManualSeibiId && this.workData.manualItems) {
        const index = this.workData.manualItems.findIndex(
          (e: any) =>
            e.inspectSeibi.sknUketsukeManualSeibiId ==
            body[0].inspectSeibi.sknUketsukeManualSeibiId
        );
        if (index > -1) {
          this.workData.manualItems.splice(index, 1);
          this.$forceUpdate();
        }
      } else if (body[0].inspectSeibi.sknUketsukeInspectSeibiId && this.workData.items) {
        const index = this.workData.items.findIndex(
          (e: any) =>
            e.inspectSeibi.sknUketsukeInspectSeibiId ==
            body[0].inspectSeibi.sknUketsukeInspectSeibiId
        );
        if (index > -1) {
          this.workData.items.splice(index, 1);
          this.$forceUpdate();
        }
      }

      //退避リストに追加する
      if (
        body[0].inspectSeibi.sknUketsukeManualSeibiId != null &&
        this.workDataAfter.manualItems
      ) {
        this.workDataAfter.manualItems = this.workDataAfter.manualItems.concat(body);
      } else if (this.workDataAfter.items) {
        this.workDataAfter.items = this.workDataAfter.items.concat(body);
      }
      this.$forceUpdate();
    }
  }
  */
  //▽[2024/03/21]kyuwa : カミタケ様向け仕様のため一旦封印


  onChangeWork(frame: any) {
    const body = util.getWSData(frame);
    if (body && body.length > 0) {
      if (body[0].inspectSeibi.sknUketsukeManualSeibiId && this.workData.manualItems) {
        const index = this.workData.manualItems.findIndex(
          (e: any) =>
            e.inspectSeibi.sknUketsukeManualSeibiId ==
            body[0].inspectSeibi.sknUketsukeManualSeibiId
        );
        if (index > -1) {
          this.workData.manualItems[index].inspectSeibi = body[0].inspectSeibi;
          this.$forceUpdate();
        }
      } else if (body[0].inspectSeibi.sknUketsukeInspectSeibiId && this.workData.items) {
        const index = this.workData.items.findIndex(
          (e: any) =>
            e.inspectSeibi.sknUketsukeInspectSeibiId ==
            body[0].inspectSeibi.sknUketsukeInspectSeibiId
        );
        if (index > -1) {
          this.workData.items[index].inspectSeibi = body[0].inspectSeibi;
          this.$forceUpdate();
        }
      }
    }
  }

  // onInspectionDotenken(frame: any) {
  //   this.$notify.info({
  //     title: "Info",
  //     message: MESSAGE.UpdatedInspections
  //   });
  //   this.getData();
  // }

  isShowGroup(workItem: any, groupIndex: number) {
    if (workItem.length > 0) {
      return true;
    }
    return false;
  }

  getOtherStaff(work: WorkItem) {
    if (work.otherStaff) {
      return work.otherStaff.staffNm;
    }
    return "その他作業者";
  }

  popupOtherStaff(e: any, work: WorkItem) {
    e.stopPropagation();
    if (!this.isUserMode) {
      this.otherStaffList = [];
      this.tempOtherStaff = null;
      this.showDialogStaff = true;
      this.tempWork = work;
      this.tempOtherStaff = this.tempWork.otherStaff;
      this.getStaff();
    }
  }

  setOtherStaffList() {
    if (this.kyotenCd == this.currentKyotenCd) {
      this.staffs = util.deepCopy(this.otherStaffData);
    }
    if (this.tempWork && this.tempWork.otherStaff) {
      let staffCd = this.tempWork.otherStaff.staffCd;
      const otherStaff = this.otherStaffData.find(
        (e: any) => e.staffCd == staffCd
      );
      if (otherStaff) {
        this.setSelectedStaff();
      } else {
        this.getStaffByKyoten(this.kyotenCd);
      }
    }
  }

  selectOtherStaff(staff: InspectStaff) {
    if (this.tempOtherStaff && staff.staffCd == this.tempOtherStaff.staffCd) {
      this.staffs = this.staffs.map(e => {
        return { ...e, selected: "0" };
      });
      this.tempOtherStaff = null;
    } else {
      this.staffs = this.staffs.map(e => {
        return { ...e, selected: e.staffCd == staff.staffCd ? "1" : "0" };
      });
      this.tempOtherStaff = {
        staffCd: staff.staffCd,
        staffNm: staff.staffNm,
        isAssignee: 1,
        kyotenCd: this.kyotenCd
      };
    }
  }

  setOtherStaff() {
    if (this.tempWork) {
      this.tempWork.otherStaff = this.tempOtherStaff;
    }
    this.showDialogStaff = false;
  }

/** 2024-02-26 change staff [START] */

  popupAddStaff() { //追加ウインドウ表示
    this.tempAddStaff1 = null;
    this.tempAddStaff2 = null;
    this.tempAddStaff3 = null;
    this.showDialogStaffSlot = true;
    this.getStaffAddList(); //スタッフリスト更新
  }

  chancelAddStaff(){

    //チェック状況の初期化
    this.checkedStaffSlot=[];

    //追加選択肢の初期化
    this.addStaffs = this.addStaffs.map(e => {
        return { ...e, selected: "0" };
      });
      this.tempAddStaff1 = null;
      this.tempAddStaff2 = null;
      this.tempAddStaff3 = null;

    this.showDialogStaffSlot=false

    //モード終了
    this.changeStaffMode = false;

  }

  selectAddStaff(staff: InspectStaff, num: number) {
    let tempAddStaff: any = null;
    if(num == 1) tempAddStaff = this.tempAddStaff1;
    if(num == 2) tempAddStaff = this.tempAddStaff2;
    if(num == 3) tempAddStaff = this.tempAddStaff3;

    if (tempAddStaff && staff.staffCd == tempAddStaff.staffCd) {
      this.addStaffs = this.addStaffs.map(e => {
      return { ...e, selected: e.selected == num.toString() ? "0" : e.selected };
      });
      tempAddStaff = null;
    } else {
      this.addStaffs = this.addStaffs.map(e => {
        return { ...e, selected: e.staffCd == staff.staffCd ? num.toString() : e.selected == num.toString() ? "0" : e.selected };
      });
      tempAddStaff = {
        num : 3, //補助整備士固定
        isAssignee: 0,
        staffCd: staff.staffCd,
        staffNm: staff.staffNm,
        kyotenCd: this.kyotenCd
      };
    }

    //参照になっているはずだが一応戻す
    if(num == 1) this.tempAddStaff1 = tempAddStaff;
    if(num == 2) this.tempAddStaff2 = tempAddStaff;
    if(num == 3) this.tempAddStaff3 = tempAddStaff;
  }

  async setAddStaff(mode:number) {
    await this.existChangeStaff(mode);
    this.chancelAddStaff();
  }

/** 2024-02-26 change staff [END] */

  destroyed() {
    this.sktControll.freeSocketResources();
  }

  onCancel() {
    if (this.$refs.cancelDialog) {
      this.$refs.cancelDialog.onOpen();
    }
  }

  cancel() {
    const data = {
      sknUketsukeExtendsId: this.uketsukeExtendsId,
      uketsukeCd: this.uketsukeCd,
      yoyakuNo: this.yoyakuNo
    };
    this.reqService.saveCancel(data).then((res: any) => {
      if (this.isUserMode) {
        this.$router.push({ name: "reservationNumber" });
      } else {
        this.$router.push({ name: "reservation" });
      }
    });
  }

  onShowDialogRecommend() {
    this.reqService.getJizenResult(this.uketsukeExtendsId).then(
      (res: any) => {
        this.showDialogRecommend = true;
        this.estData = res.jizenResult;
        this.setSeibiData();
      },
      (err: any) => {
      }
    );
  }

  onCloseDialogRecommend() {
    this.showDialogRecommend = false;
  }

  setSeibiData() {
    this.estData.forEach((element: any) => {
      if (element.osusume) {
        element.recommend.forEach((sub: any) => {
          if (sub.subItems && sub.subItems.length > 0) {
          sub.subItems.forEach((item: any) => {
            if (item.buhinEditTotalZn == null) {
              item.buhinEditTotalZn = item.buhinZn;
            }
            if (item.buhinEditTotalZk == null) {
              item.buhinEditTotalZk = item.buhinZk;
            }
            if (item.kouchinEditZn == null) {
              item.kouchinEditZn = item.kouchinZn;
            }
            if (item.kouchinEditZk == null) {
              item.kouchinEditZk = item.kouchinZk;
            }
            item.totalZk = item.buhinEditTotalZk + item.kouchinEditZk;
            item.totalZn = item.buhinEditTotalZn + item.kouchinEditZn;
          });
          }
        });
      } else {
        if (element.subItems && element.subItems.length > 0) {
          if (element.subItems && element.subItems.length > 0) {
          element.subItems.forEach((sub: any) => {
            if (sub.subItems && sub.subItems.length > 0) {
              sub.subItems.forEach((item: any) => {
                if (item.buhinEditTotalZn == null) {
                  item.buhinEditTotalZn = item.buhinZn;
                }
                if (item.buhinEditTotalZk == null) {
                  item.buhinEditTotalZk = item.buhinZk;
                }
                if (item.kouchinEditZn == null) {
                  item.kouchinEditZn = item.kouchinZn;
                }
                if (item.kouchinEditZk == null) {
                  item.kouchinEditZk = item.kouchinZk;
                }
                item.totalZk = item.buhinEditTotalZk + item.kouchinEditZk;
                item.totalZn = item.buhinEditTotalZn + item.kouchinEditZn;
              });
            }
          });
          }
        }
      }
    });
  }

  /** 2021-09-10 sh #7372 fix button of jizen mitsumori.(check JizenCd from MD-0002 ) [START] */
  checkIsCanJizen() {
    // console.log("workOrder.checkIsCanJizen isDoJizen => ", this.isDoJizen);
    // console.log("workOrder.checkIsCanJizen isCanJizenMitsumori => ", this.isCanJizenMitsumori);
    return this.isCanJizenMitsumori && this.isDoJizen;
  }
  /** 2021-09-10 sh #7372 fix button of jizen mitsumori.(check JizenCd from MD-0002 ) [END] */

  onfactoryGetData(frame: any) {
    this.getData();
  }

  getNavigationJoukyou() {
    this.reqService.getNavigationJoukyou(this.uketsukeExtendsId).then((res: any) => {
      if (res == true) {
        this.title = '【注意事項】入庫車両の点検は全てお済みでしょうか？';
        this.joukyouErrorMsg = '完了になっていない点検があります。<br>追加整備を完了にしますか？';
        this.$refs.joukyouDialog.onOpen();
      } else {
        this.onRegister();
      }
    });
  }

/** 2024-02-26 change staff [START] */

  checkChangeStaff(key_s:number,key_i:number,key_j:number){
    //同一作業内でのチェックは1件だけにするための確認
    let flag:boolean = false;
    for( let i = 0; i < this.checkedStaffSlot.length ; i++ ){
      if( this.checkedStaffSlot[i].s == key_s && this.checkedStaffSlot[i].i == key_i ){
        if( this.checkedStaffSlot[i].j == key_j ){
          return false; //選択中の内容
        }else{
          flag = true;
        }
      }
    }
    return flag;
  }

  existChangeStaff(mode:number){
    //変更前作業実施者リストの生成
    let staffslot:any = [];
    let keys:any =[];
    let keys2:any =[];
    for( let i = 0; i < this.seibiListByResult.length ; i++ ){
      if ( !( i in staffslot ) ) staffslot[i] = [];
      for( let j = 0; j < this.seibiListByResult[i].length ; j++ ){
        if ( !( j in staffslot[i] ) ) staffslot[i][j] = [];
        for( let k = 0; k < this.seibiListByResult[i][j].seibiStaff.length ; k++ ){
          staffslot[i][j][k] = false;
        }
      }
    }
    //削除スタッフ指示リストの作成
    for( let i = 0; i < this.checkedStaffSlot.length ; i++ ){
      keys = this.checkedStaffSlot[i]; 
      if( keys.s in staffslot ){
        if(  keys.i in staffslot[keys.s] ){
          if(  keys.j in staffslot[keys.s][keys.i] ){
            staffslot[keys.s][keys.i][keys.j] = true;
          }
        }
      }
    }
    //スタッフ削除
    let useStaffCnt = 0;
    for( let i = 0; i < staffslot.length ; i++ ){
      for( let j = 0; j < staffslot[i].length ; j++ ){
        useStaffCnt = 0;
        keys2 = this.seibiListByResult[i][j].seibiStaff; 
        if( this.tempAddStaff1 != null ){
          useStaffCnt++;
        } 
        if( this.tempAddStaff2 != null  ){
          useStaffCnt++;
        }
        if( this.tempAddStaff3 != null  ){
          useStaffCnt++;
        }
        for( let k = 0 ; k < staffslot[i][j].length ; k++ ){
          //同じスタッフを重複配置しないよう、配列の最後に行くまでに重複チェックした結果、対象が0にならないかチェック
            if( this.tempAddStaff1 != null && keys2.length > k ){
              if(keys2[k].staffCd == this.tempAddStaff1.staffCd ) useStaffCnt--;
            } 
            if( this.tempAddStaff2 != null && keys2.length > k ){
              if(keys2[k].staffCd == this.tempAddStaff2.staffCd ) useStaffCnt--;
            }
            if( this.tempAddStaff3 != null && keys2.length > k ){
              if(keys2[k].staffCd == this.tempAddStaff3.staffCd ) useStaffCnt--;
            }
        }
        for( let k = staffslot[i][j].length -1 ; k >= 0 ; k-- ){
          if( staffslot[i][j][k] == true ){
            if( mode == 1 || useStaffCnt > 0){
              console.log("mm",useStaffCnt);
              this.seibiListByResult[i][j].seibiStaff.splice(k, 1);
            }
          //  staffslot[i][j][k] = false;
          }
          //staffslot[i][j][k] = false;
        }
      }
    }

    //削除指示はここで止める
    if( mode == 1 ){
      return;
    }

    //変更前作業実施者リストに追加分の枠を加えて作業実施者枠のリストに加工
    for( let i = 0; i < this.seibiListByResult.length ; i++ ){
      if ( !( i in staffslot ) ) staffslot[i] = [];
      for( let j = 0; j < this.seibiListByResult[i].length ; j++ ){
        if ( !( j in staffslot[i] ) ) staffslot[i][j] = [];
      //  for( let k = 0; k < this.seibiListByResult[i][j].seibiStaff.length ; k++ ){
      //    staffslot[i][j][k] = false;
      //  }
        for( let k = this.seibiListByResult[i][j].seibiStaff.length ;  k < 3 ; k++ ){//登録。
          staffslot[i][j][k] = false;
        }

      }
    }
    //登録スタッフ位置リストの作成(チェックボックス設置条件の都合で表示上限以上の選択は出ない)
    for( let i = 0; i < this.checkedStaffSlot.length ; i++ ){
      keys = this.checkedStaffSlot[i]; 
      if( keys.s in staffslot ){
        if(  keys.i in staffslot[keys.s] ){
          if(  keys.j in staffslot[keys.s][keys.i] ){
            staffslot[keys.s][keys.i][keys.j] = true;
          }
        }
      }
    }
    //モーダルで選択されたスタッフを左詰めで追加
    let useStaff1 = false;
    let useStaff2 = false;
    let useStaff3 = false;
    for( let i = 0; i < staffslot.length ; i++ ){
      for( let j = 0; j < staffslot[i].length ; j++ ){
        //作業部品が切り替わるごとに初期化する
        useStaff1 = false;
        useStaff2 = false;
        useStaff3 = false;
        keys2 = this.seibiListByResult[i][j].seibiStaff; 
        for( let k = 0 ; k < staffslot[i][j].length ; k++ ){
          //同じスタッフを重複配置しないよう、配列の最後に行くまでに重複チェック
            if( this.tempAddStaff1 != null && !useStaff1 && keys2.length > k ){
              if(keys2[k].staffCd == this.tempAddStaff1.staffCd ) useStaff1 = true;
            } 
            if( this.tempAddStaff2 != null && !useStaff2 && keys2.length > k ){
              if(keys2[k].staffCd == this.tempAddStaff2.staffCd ) useStaff2 = true;
            }
            if( this.tempAddStaff3 != null && !useStaff3 && keys2.length > k ){
              if(keys2[k].staffCd == this.tempAddStaff3.staffCd ) useStaff3 = true;
            }
        }
        for( let k = 0 ; k < staffslot[i][j].length ; k++ ){
          if( staffslot[i][j][k] == true ){
            if( this.tempAddStaff1 != null && useStaff1 == false ){
              this.seibiListByResult[i][j].seibiStaff.push(util.deepCopy(this.tempAddStaff1));
              useStaff1 = true;
            }else if ( this.tempAddStaff2 != null && useStaff2 == false ){ 
              this.seibiListByResult[i][j].seibiStaff.push(util.deepCopy(this.tempAddStaff2));
              useStaff2= true;
            }else if ( this.tempAddStaff3 != null && useStaff3 == false  ){ 
              this.seibiListByResult[i][j].seibiStaff.push(util.deepCopy(this.tempAddStaff3));
              useStaff3 = true;
            }
          }
        }
      }
    }
  }
/** 2024-02-26 change staff [END] */

  onCloseJoukyouError() {
    this.title = '';
    this.joukyouErrorMsg = '';
  }

  sendPutNavigation() {
    // gensha
    const gensha: any = {
      uketsukeExtendId: this.uketsukeExtendsId,
      screenId: 2,
      status: 2
    };
    this.reqService.putNavigation(gensha).then(
      (res: any) => {
        // legal56
        const legal56: any = {
          uketsukeExtendId: this.uketsukeExtendsId,
          screenId: 4,
          status: 2
        };
        this.reqService.putNavigation(legal56).then(
          (res: any) => {
            this.onRegister();
          },
          (error: any) => {}
        );
      },
      (error: any) => {}
    );
  }

  /** 2022-12-08 sh #8122(BQR982) reload after change shaken-shurui. [START] */
  @Watch("seibiMenuCd")
  reInitData() {
    this.loading = true;
    this.getData();
  }
  /** 2022-12-08 sh #8122(BQR982) reload after change shaken-shurui. [END] */
}
